import {Component, Input, ViewEncapsulation} from '@angular/core';
import {LaColorService} from '../colors/la-color.service';

@Component({
  selector: 'la-text',
  template: `
    <div class="la-text" [ngClass]="{
      'la-text--display': kind === 'display',
      'la-text--title-1': kind === 'title-1',
      'la-text--title-2': kind === 'title-2',
      'la-text--title-3': kind === 'title-3',
      'la-text--title-4': kind === 'title-4',
      'la-text--caption': kind === 'caption',
      'la-text--button': kind === 'button'
}" [style.color]="color">
      <ng-content></ng-content>
    </div>
  `,
  styles: [`
    @font-face{font-family:NeueHaasGrotDisp-45Light;font-style:normal;font-weight:300;src:url(assets/fonts/NeueHaasGrotDisp-45Light.woff) format("woff")}@font-face{font-family:NeueHaasGrotDisp-55Roman;font-style:normal;font-weight:400;src:url(assets/fonts/NeueHaasGrotDisp-55Roman.woff) format("woff")}@font-face{font-family:NeueHaasUnicaPro;font-style:normal;font-weight:400;src:url(assets/fonts/NeueHaasUnicaPro-Regular.woff) format("woff")}@font-face{font-family:NeueHaasUnicaPro;font-style:normal;font-weight:500;src:url(assets/fonts/NeueHaasUnicaPro-Medium.woff) format("woff")}.la-text.la-text--display{font-size:34px;font-family:NeueHaasGrotDisp-45Light,sans-serif;font-weight:300;letter-spacing:-1.4px;line-height:40px}.la-text.la-text--title-1{font-size:23px;font-family:NeueHaasGrotDisp-55Roman,sans-serif;font-weight:400;letter-spacing:-.55px;line-height:28px}.la-text.la-text--title-2{font-size:17px;letter-spacing:-.6px;line-height:20.4px}.la-text.la-text--title-2,.la-text.la-text--title-3{font-family:NeueHaasUnicaPro,sans-serif;font-weight:400}.la-text.la-text--title-3{font-size:15px;letter-spacing:-.62px;line-height:18px}.la-text.la-text--title-4{font-weight:400}.la-text.la-text--caption,.la-text.la-text--title-4{font-size:13px;font-family:NeueHaasUnicaPro,sans-serif;letter-spacing:-.34px;line-height:16px}.la-text.la-text--caption{font-weight:500}.la-text.la-text--button{font-size:17px;font-family:NeueHaasUnicaPro,sans-serif;font-weight:500;text-align:center;letter-spacing:-.7px;line-height:20.4px}.la-text{display:inline}
  `],
  encapsulation: ViewEncapsulation.None
})
export class LaTextComponent {
  private _kind: string;
  private _color: string;

  constructor(private _colorService: LaColorService) {
  }

  get kind(): string {
    return this._kind;
  }

  @Input()
  set kind(kind: string) {
    this._kind = kind;
  }

  get color(): string {
    return this._color;
  }

  @Input()
  set color(name: string) {
    this._color = this._colorService.getColorByName(name);
  }
}
